"use client";

import { c as _c } from "react/compiler-runtime";
import { ContextCurrencyFragment } from "@opensea/app-kit";
import { graphql, useQuery } from "@opensea/graphql";
import { NETWORK_ONLY_OPERATION_CONTEXT } from "../constants";
const TopCurrenciesQuery = graphql(`
    query topCurrencies(
      $filter: CurrenciesFilter!
      $limit: Int!
      $sort: CurrenciesSort!
    ) {
      topCurrencies(filter: $filter, limit: $limit, sort: $sort) {
        items {
          name
          symbol
          imageUrl
          chain {
            identifier
          }
          contractAddress
          usdPrice
          decimals
          isSwapDisabled
          ...ContextCurrency
        }
      }
    }
  `, [ContextCurrencyFragment]);
export const useTopCurrencies = params => {
  const $ = _c(15);
  const {
    filter,
    pause,
    sort
  } = params;
  let t0;
  if ($[0] !== filter || $[1] !== sort) {
    t0 = {
      filter,
      sort,
      limit: 50
    };
    $[0] = filter;
    $[1] = sort;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== pause || $[4] !== t0) {
    t1 = {
      query: TopCurrenciesQuery,
      variables: t0,
      pause,
      context: NETWORK_ONLY_OPERATION_CONTEXT
    };
    $[3] = pause;
    $[4] = t0;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const [t2, refetch] = useQuery(t1);
  const {
    data,
    error,
    fetching
  } = t2;
  let t3;
  if ($[6] !== data?.topCurrencies.items) {
    t3 = data?.topCurrencies.items ?? [];
    $[6] = data?.topCurrencies.items;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== refetch) {
    t4 = () => refetch({
      requestPolicy: "network-only"
    });
    $[8] = refetch;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== error || $[11] !== fetching || $[12] !== t3 || $[13] !== t4) {
    t5 = {
      currencies: t3,
      error,
      fetching,
      refetch: t4
    };
    $[10] = error;
    $[11] = fetching;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};